"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M15.587 1.15h-2.21v1.01h1.627v1.53H16V1.563a.413.413 0 0 0-.413-.414Zm-12.964 1-1.657.004V3.69H0V1.564c0-.228.185-.413.413-.413h2.21v.999Zm10.62 1.735-10.52-.056v8.394l10.52-.051V3.885ZM1.73 12.755v-9.48c0-.227.185-.412.463-.412h11.688c.178 0 .363.185.363.413v9.479a.413.413 0 0 1-.413.414H2.143a.413.413 0 0 1-.413-.414Zm-.764-.432H.021v2.125c0 .229.185.414.414.414h2.21v-1.006H.965v-1.533Zm12.41 1.555h1.627v-1.555H16v2.125a.414.414 0 0 1-.414.414h-2.21v-.984Zm-6.26-8.883a2.935 2.935 0 1 1-2.109 4.793A2.645 2.645 0 0 0 8.37 7.245c0-.95-.502-1.784-1.255-2.25Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M3.934 2.958H1.24v2.568H0V2.338a.62.62 0 0 1 .62-.62h3.314v1.24Zm16.193 15.547H3.836V5.527h16.291v12.978Zm-17.531.62V4.906a.62.62 0 0 1 .62-.62h17.532a.62.62 0 0 1 .62.62v14.219a.62.62 0 0 1-.62.62H3.216a.62.62 0 0 1-.62-.62Zm-1.323-.649H.033v3.188c0 .343.277.62.62.62h3.314v-1.151H1.273v-2.657Zm18.792 2.657h2.801v-2.657H24v3.188a.62.62 0 0 1-.62.62h-3.315v-1.151ZM23.38 1.718h-3.314V2.84h2.801v2.685H24V2.338a.62.62 0 0 0-.62-.62ZM10.671 7.485a4.403 4.403 0 1 1-3.163 7.19 3.964 3.964 0 0 0 3.163-7.19Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5.246 3.944H1.654v3.424H0v-4.25c0-.458.37-.828.827-.828h4.419v1.654Zm21.59 20.729H5.114V7.369h21.722v17.304ZM3.46 25.5V6.542c0-.457.37-.827.827-.827h23.376c.456 0 .826.37.826.827V25.5c0 .456-.37.826-.826.826H4.287a.826.826 0 0 1-.827-.826Zm-1.763-.866H.043v4.25c0 .458.371.828.827.828h4.419v-1.536H1.697v-3.542Zm25.058 3.542h3.735v-3.542H32v4.25c0 .458-.37.828-.826.828h-4.42v-1.536ZM31.174 2.29h-4.42v1.497h3.735v3.581h1.512v-4.25a.827.827 0 0 0-.827-.828ZM14.229 9.98a5.871 5.871 0 1 1-4.217 9.586A5.285 5.285 0 0 0 14.23 9.98Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M46.72 3.545h-6.843v1.978h6.157v5.885H48V4.825a1.28 1.28 0 0 0-1.28-1.28ZM8.123 5.523h-6.22v5.885H0V4.825c0-.707.574-1.28 1.28-1.28h6.843v1.978Zm33.382 32.531H6.38V9.915h35.126v28.14Zm-36.921.654V9.354c0-.707.574-1.28 1.28-1.28H42.06c.708 0 1.28.573 1.28 1.28v29.354a1.28 1.28 0 0 1-1.28 1.28H5.864a1.28 1.28 0 0 1-1.28-1.28Zm-2.682-2.114H.066v6.583c0 .707.573 1.28 1.28 1.28H8.19v-2.046H1.902v-5.817Zm37.975 5.818h6.157v-5.817H48v6.582a1.28 1.28 0 0 1-1.28 1.28h-6.843v-2.045Zm-18.62-27.734a9.092 9.092 0 1 1-6.53 14.843c.712.2 1.46.308 2.235.308a8.185 8.185 0 0 0 4.296-15.151Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M62.292 4.727h-9.123v2.637h8.209v7.847h2.62V6.434c0-.942-.763-1.707-1.706-1.707ZM10.83 7.364H2.537v7.847H0V6.434c0-.943.765-1.707 1.707-1.707h9.123v2.637Zm44.509 43.375H8.504v-37.52h46.835v37.52Zm-49.228.87V12.473c0-.943.765-1.707 1.707-1.707h48.26c.943 0 1.707.764 1.707 1.707V51.61c0 .942-.764 1.707-1.707 1.707H7.818a1.708 1.708 0 0 1-1.707-1.707Zm-3.574-2.817H.089v8.777c0 .944.764 1.707 1.707 1.707h9.123v-2.728H2.537v-7.756ZM53.17 56.55h8.209v-7.756h2.62v8.777c0 .942-.764 1.707-1.706 1.707H53.17V56.55ZM28.343 19.57c.221-.013.443-.019.667-.019 6.694 0 12.122 5.427 12.122 12.122 0 6.694-5.428 12.121-12.122 12.121a12.101 12.101 0 0 1-9.373-4.434c.947.268 1.946.412 2.978.412 6.027 0 10.914-4.886 10.914-10.913 0-3.926-2.075-7.367-5.186-9.289Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconNightVision = function IconNightVision(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Night Vision' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "NightVision"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconNightVision.sizes = [16, 24, 32, 48, 64];
IconNightVision.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconNightVision;
exports.default = _default;